import { atom } from "jotai";

export type NodeViewMode = "collapsed" | "expanded";

export const nodeViewModeAtom = atom<NodeViewMode>("collapsed");
nodeViewModeAtom.debugLabel = "nodeViewModeAtom";

export type NodeMetric =
  | "zapRuns"
  | "formSubmissionCount"
  | "tableRecordUsage"
  | "timeSpentOrSaved";

// Try not to use this but instead use the fine-grained selectors below for better perf
export const nodeMetricsToDisplayAtom = atom<NodeMetric[]>([]);
nodeMetricsToDisplayAtom.debugLabel = "nodeMetricsToDisplayAtom";

// Derived atoms for individual metrics to prevent unnecessary re-renders
export const showZapRunsAtom = atom((get) =>
  get(nodeMetricsToDisplayAtom).includes("zapRuns"),
);
showZapRunsAtom.debugLabel = "showZapRunsAtom";

export const showFormSubmissionCountAtom = atom((get) =>
  get(nodeMetricsToDisplayAtom).includes("formSubmissionCount"),
);
showFormSubmissionCountAtom.debugLabel = "showFormSubmissionCountAtom";

export const showTableRecordUsageAtom = atom((get) =>
  get(nodeMetricsToDisplayAtom).includes("tableRecordUsage"),
);
showTableRecordUsageAtom.debugLabel = "showTableRecordUsageAtom";

export const showTimeSpentOrSavedAtom = atom((get) =>
  get(nodeMetricsToDisplayAtom).includes("timeSpentOrSaved"),
);
showTimeSpentOrSavedAtom.debugLabel = "showTimeSpentOrSavedAtom";
